export default __webpack_public_path__ + "static/icon-tile-color-dark-e7bed35b820947025cf08d18e3f72ba141727f5b9cbda7606965dd6654028cc0.png";